import Quantity from "./quantity.js";
import { dom, mapActiveClass } from "../helpers/dom.js";

class FullQuantity {
  constructor(props) {
    this._limit = props.limit || 0;
    this._initialValue = props.initialValue || 0;
    this._onChange = props.onChange || (() => {});
  }
  init() {
    this.dom = this._makeDom();
    return this.dom;
  }
  initWidget() {
    this._widget = new Quantity({
      base: this.dom,
      limit: this._limit,
      onChange: this._onChange
    });
    this.setValue(this._initialValue);
  }
  setValue(newValue) {
    if (this._widget) {
      this._widget.setValue(newValue);
    }
  }
  updateLimit(newLimit) {
    if (this._widget) {
      this._widget.updateLimit(newLimit);
    }
  }
  _makeDom() {
    return dom("div.quantity.quantity--full", {}, [
      dom("button.quantity__minus", {}, "-"),
      dom("input.quantity__value", { type: "text", name: "count" }, null),
      dom("button.quantity__plus", {}, "+")
    ]);
  }
}

export default FullQuantity;



// WEBPACK FOOTER //
// ./src/js/components/fullQuantity.js